import {useSelector} from "react-redux";
import {selectTrainingLocalizationState} from "../app/slices/TrainingLocalizationSlice";
import LocalizedLanguageDTO, {LocalizedLanguageEntryDTO,} from "../dto/LocalizedLanguageDTO";

export const UseSerializeLocalization = () => {
    const locState = useSelector(selectTrainingLocalizationState);
    const serializeLanguage = (shortcode: string) => {
        var keys = Object.keys(locState.localizedEntries);
        var entries: LocalizedLanguageEntryDTO[] = [];

        for (var k = 0; k < keys.length; k++) {
            const localizedEntry = locState.localizedEntries[keys[k]][shortcode];
            entries.push({
                key: keys[k],
                value: localizedEntry?.value ?? "",
                isAutoTranslated: localizedEntry?.isAutoTranslated ?? false,
            });
        }

        var dto: LocalizedLanguageDTO = {
            lang: shortcode,
            entries: entries,
        };

        return dto;
    };


    const serializeLanguageForTesting = (shortcode: string) => {
        var keys = Object.keys(locState.localizedEntries);
        var entries: LocalizedLanguageEntryDTO[] = [];

        for (var k = 0; k < keys.length; k++) {
            const localizedEntry = locState.localizedEntries[keys[k]][shortcode];
            const value = localizedEntry?.value ?? "";
            entries.push({
                key: keys[k],
                value: value !== "" ? value : " ",
                isAutoTranslated: localizedEntry?.isAutoTranslated ?? false,
            });
        }

        var dto: LocalizedLanguageDTO = {
            lang: shortcode,
            entries: entries,
        };

        return dto;
    }


    return {serializeLanguage, serializeLanguageForTesting} as const;
};
